import Container from './ThreadPage.container';
import Component from './ThreadPage';

export default Container(Component);
